// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedInTopWeb3Section_container__2bf3o","list":"FeaturedInTopWeb3Section_list__DGhay"};